import { useRef } from 'react'

const useDebounce = (delay = 500) => {
  const timerRef = useRef(null)
  return (callback) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      callback()
    }, delay)
  }
}

export default useDebounce
